// @ts-check
/// <reference path="au-cart-types.js" />

/**
 * @class
 */
class auCartUtils {
  /**
   * @param {number} num price
   * @returns {string} formatted price in US dollars (USD)
   */
  static formatPrice(num) {
    const priceNumber = num / 100;
    const priceString = priceNumber.toLocaleString('en', {
      style: 'currency',
      currency: 'USD',
    });
    return priceString;
  }

  /**
   * Updates the active state of navigation dots based on the current slide index.
   *
   * @param {HTMLElement} dotContainer - The container element that holds the navigation dots.
   * @param {number} slideIndex - Index of the currently active slide.
   */
  static setActiveSlide(dotContainer, slideIndex) {
    const buttons = Array.from(dotContainer.querySelectorAll('button'));
    buttons.forEach((button, index) => {
      button.classList.toggle('is-active', index === slideIndex);
    });
  }

  /**
   * Initializes a Siema slider with custom navigation dots and binds click events.
   *
   * @param {HTMLElement} sliderContainer - The parent element containing the slider and navigation.
   * @param {Array<string>} slidesData - Data array used to generate navigation dots.
   */
  static initSlider(sliderContainer, slidesData) {
    const dotContainer = /** @type {HTMLElement} */ (
      sliderContainer.querySelector('.images-navigation')
    );

    if (!sliderContainer.children?.length) return;

    const slider = new Siema({
      selector: /** @type {HTMLElement} */ (sliderContainer.children[0]),
      perPage: 1,
      startIndex: 0,
      draggable: true,
      loop: true,
      onChange: () => this.setActiveSlide(dotContainer, slider.currentSlide),
    });

    if (slidesData.length > 1) {
      slidesData.forEach((_, index) => {
        const dotItem = document.createElement('li');
        dotItem.classList.add('au-slider-li');

        const dotButton = document.createElement('button');
        dotButton.classList.add('au-slider-button');
        dotButton.type = 'button';

        if (index === 0) {
          dotButton.classList.add('is-active');
        }

        dotButton.addEventListener('click', () => {
          this.setActiveSlide(dotContainer, index);
          slider.goTo(index);
        });

        dotItem.appendChild(dotButton);
        dotContainer.appendChild(dotItem);
      });
    }

    // Trigger resize event for Firefox rendering fix
    window.dispatchEvent(new CustomEvent('resize'));
  }

  /**
   * Converts input value into a finite number or returns NaN if invalid.
   *
   * @param {string|number|null|undefined} rawValue - Raw input value (e.g., string or number).
   * @returns {number} Parsed number or NaN if invalid.
   */
  static parseQuantityInput(rawValue) {
    return Number(rawValue);
  }
}
